import { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectSearchMetaRefreshing, selectSearchResultsText } from 'shared/selectors/searchMeta';
import { AllFiltersModalFooter } from '../../../../components/AllFiltersModalFooter/AllFiltersModalFooter';

interface IAllFiltersModalFooterContainerProps {
  onFiltersReset: VoidFunction;
  onFiltersApply: VoidFunction;
}

export const AllFiltersModalFooterContainer: FC<IAllFiltersModalFooterContainerProps> = ({
  onFiltersReset,
  onFiltersApply,
}) => {
  const isSearchMetaRefreshing = useSelector(selectSearchMetaRefreshing);
  const searchButtonText = useSelector(selectSearchResultsText);

  return (
    <AllFiltersModalFooter
      searchButtonText={searchButtonText}
      isCounterRefreshing={isSearchMetaRefreshing}
      onClearClick={onFiltersReset}
      onShowClick={onFiltersApply}
    />
  );
};
